'use client';
import {AuthPageView} from '@web-libs/features/auth/shared/ui/auth-page.view';
import {RegisterIllustration} from '@web-libs/features/auth/register/ui/register-illustration';
import {useCmsPage} from '@web-libs/features/cms/application/use-cms-page.concern';
import {useDictionaryContext} from '@web-libs/core/internationalization/dictionary.context';
import {useEffect} from 'react';
import {Loader} from '@web-libs/ui/ui-components/loader/loader.component';
import {CmsCardElement} from '@web-libs/features/cms/domain/cms.types';
import {CmsRegistrationCard} from '@web-libs/features/cms/ui/CmsRegistrationCard';
import { useTenant } from '@web-libs/core/context/tenant-context';

export const RegisterPageView = () => {

    const tenant = useTenant()
    const enableAnonymous = tenant.enableAnonymousRegistration

    useEffect(() => {
                  fetchCmsPage('REGISTRATION');
              },
              []);

    const registerIllustration = <div style={{maxHeight: '100%'}}><RegisterIllustration></RegisterIllustration></div>;
    const dict = useDictionaryContext();

    const {fetchCmsPage, cmsPage, loading, error} = useCmsPage();
    const errorMessage = error ? dict.error.loadingError : undefined;


    return (
        <Loader value={cmsPage} loading={loading} error={errorMessage}>
            {function(cmsPage) {
                const card = cmsPage.elements[0] as CmsCardElement;
                const props = {...card, enableAnonymous};
                return <AuthPageView illustration={registerIllustration} card={CmsRegistrationCard(props)}/>;
            }}
        </Loader>
    );
};
